module.exports = __webpack_public_path__ + "img/festa7.afe68489.png";